import React from 'react';
import './Panel.scss';

export default function Panel ({children, title, details, description, footer, primary, panelStyle = {}, headerStyle = {}, headerMainStyle = {}, contentStyle = {}, detailStyle = {}, footerStyle = {}}) {
    return (
        <div className={'panel ' + (primary ? 'primary' : '')} style={panelStyle}>
            <div className='panel--header' style={headerStyle}>
                <div className='panel--header--main' style={headerMainStyle}>
                    <div className='panel--header--main--title'>
                        <h3>{title}</h3>
                    </div>
                    {
                        description ? 
                            <div className='panel--header--main--description'>
                                <span>{description}</span>
                            </div>
                        : null
                    }
                </div>
                {
                    details ? 
                        <div className='panel--header--details' style={detailStyle}>
                            <div>{details}</div>
                        </div>
                    : null
                }
                
            </div>
            <div className='panel--content' style={contentStyle}>
                {children}
            </div>
            {
                footer ? 
                    <div className='panel--footer' style={footerStyle}>
                        {footer}
                    </div>
                : null
            }
            
        </div>
    );
};